import styled from 'styled-components';

export const ModalContent = styled.div``;

export const Content = styled.div`
  padding: 30px 30px;
`;

export const SelectPage = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  h4 {
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    color: ${(props) => props.theme.color.text.tertiary};
  }
`;

export const DataInputPage = styled.div`
  display: flex;

  flex-direction: column;
  h4 {
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    color: ${(props) => props.theme.color.text.tertiary};
    text-align: justify;

    b {
      font-weight: ${(props) => props.theme.font.title.weight.bold};
    }
    margin-bottom: 20px;
  }

  p {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.primary};
    a {
      font-size: ${(props) => props.theme.font.body.size.small};
      color: ${(props) => props.theme.color.text.secondary};
    }

    margin-bottom: 20px;
  }
  ol {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.primary};
    a {
      font-size: ${(props) => props.theme.font.body.size.small};
      color: ${(props) => props.theme.color.text.secondary};
    }
  }
`;

export const LoadingPage = styled.div`
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InvertersContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* flex-wrap: wrap; */
  overflow-x: hidden;
  overflow: auto;
  gap: 30px;
  margin-bottom: 30px;
  margin-top: 20px;
  /* z-index: 0; */
  /* align-self: center; */
`;

export const InversorCard = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;

  align-items: center;
  border-radius: 3px;
  border: ${(props) => (props.isSelected ? '2px' : '1px')} solid;
  padding: 10px 10px;
  border-color: ${(props) =>
    props.isSelected
      ? props.theme.color.ui.green
      : props.theme.color.ui.shade2};

  cursor: pointer;

  img {
    width: 120px;
    height: 120px;
  }

  &:hover {
    background-color: ${(props) => props.theme.color.ui.shade1};
    /* transition: opacity 1s; */
  }

  h4 {
    margin-top: 16px;
    font-family: ${(props) => props.theme.font.title.family};
    font-size: ${(props) => props.theme.font.title.size.h2};
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    color: ${(props) => props.theme.color.text.tertiary};
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px;
`;
